import * as THREE from 'three';
import { tween } from './anim';

// Floating "+n" / value text that rises and fades — the value-up feedback from the original game.

const texCache = new Map<string, THREE.CanvasTexture>();

function textTexture(text: string, color: string): THREE.CanvasTexture {
  const key = `${text}|${color}`;
  const cached = texCache.get(key);
  if (cached) return cached;
  const w = 256;
  const h = 128;
  const cv = document.createElement('canvas');
  cv.width = w;
  cv.height = h;
  const ctx = cv.getContext('2d')!;
  ctx.font = '700 78px Cinzel, Georgia, serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineWidth = 8;
  ctx.strokeStyle = 'rgba(0,0,0,0.55)';
  ctx.strokeText(text, w / 2, h / 2);
  ctx.fillStyle = color;
  ctx.fillText(text, w / 2, h / 2);
  const tex = new THREE.CanvasTexture(cv);
  tex.colorSpace = THREE.SRGBColorSpace;
  texCache.set(key, tex);
  return tex;
}

export function spawnFloatText(
  parent: THREE.Object3D,
  worldPos: THREE.Vector3,
  text: string,
  color = '#ffd27a',
): void {
  const mat = new THREE.SpriteMaterial({
    map: textTexture(text, color),
    transparent: true,
    depthTest: false,
  });
  const sprite = new THREE.Sprite(mat);
  sprite.position.copy(worldPos);
  sprite.position.y += 0.6;
  sprite.scale.set(1.0, 0.5, 1);
  sprite.renderOrder = 999;
  parent.add(sprite);
  const startY = sprite.position.y;
  tween(
    900,
    (t) => {
      sprite.position.y = startY + t * 1.3;
      mat.opacity = 1 - t * t;
    },
    {
      onComplete: () => {
        sprite.removeFromParent();
        mat.dispose();
      },
    },
  );
}
